<div class="scroll-navigation__container">
  @for (navItem of navItemValues; track navItem) {
    <app-nav-item
      [class.is-active]="navItem.active"
      [class.is-groupelement]="navItem.groupHeader"
      (click)="navigateTo(navItem)"
      a11yKeyboardClickable
    >{{ navItem.label | translate }}</app-nav-item>
  }
</div>
